import {create} from 'zustand';

type DivergentAttemptsState = {
	divergentAttempts: number;
	incrementAttempts: () => void;
	reset: () => void;
};

export const useDivergentAttemptsStore = create<DivergentAttemptsState>(set => ({
	divergentAttempts: 0,

	incrementAttempts: () =>
		set(state => ({
			divergentAttempts: state.divergentAttempts + 1,
		})),

	reset: () => set({divergentAttempts: 0}),
}));
